import type { FC } from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '@components/Layout';
import HomePage from './HomePage';

const HomePageWrapper: FC = () => {
  const [activeTab, setActiveTab] = useState('mission');
  const location = useLocation();

  // Sync tab with URL hash
  useEffect(() => {
    if (location.hash) {
      const tab = location.hash.substring(1);
      if (['mission', 'services', 'about', 'contact'].includes(tab)) {
        setActiveTab(tab);
      }
    }
  }, [location.hash]);

  return (
    <Layout showHomeTabs activeTab={activeTab} onTabChange={setActiveTab}>
      <HomePage activeTab={activeTab} setActiveTab={setActiveTab} />
    </Layout>
  );
};

export default HomePageWrapper;
